// @flow
import React from 'react'
import RangeCondition from './RangeCondition'
import { cutDigit } from '../../utils'
import listenToClickOutside from 'react-onclickoutside'
import { RangeParams, ConditionName } from '../../actions'

export type Props = {
  name: ConditionName
  open: boolean
  from?: number
  to?: number
  hasError: boolean
  onToggle: (cond: ConditionName) => any
  onRemove: (cond: ConditionName) => any
  onSet: (cond: ConditionName, range: RangeParams) => any
}

const renderAmountRangeCondition = (RangeCondition: any): React.FC<Props> => {
  const amountRangeCondition = (props: Props) => {
    return (
      <RangeCondition
        {...props}
        annotation="百万円"
        useLabelAnnotation
        from={cutDigit(props.from)}
        to={cutDigit(props.to)}
        onSet={(name: any, range: any) =>
          props.onSet(name, {
            from: multiplyDigit(range.from),
            to: multiplyDigit(range.to),
          })
        }
      />
    )
  }
  return amountRangeCondition
}

export const multiplyDigit = (n?: number) => (n != null ? n * 1000 : null)

// @ts-ignore
const AmountRangeCondition = renderAmountRangeCondition(
  listenToClickOutside(RangeCondition)
)
// @ts-ignore
AmountRangeCondition.displayName = 'AmountRangeCondition'

export default AmountRangeCondition
